import { render, staticRenderFns } from "./MedOcuPersonal.vue?vue&type=template&id=0e6ad430&scoped=true"
import script from "./MedOcuPersonal.vue?vue&type=script&lang=js"
export * from "./MedOcuPersonal.vue?vue&type=script&lang=js"
import style0 from "./MedOcuPersonal.vue?vue&type=style&index=0&id=0e6ad430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6ad430",
  null
  
)

export default component.exports